<template>
  <header v-if="$store.getters.isUserLogged">
    <nav class="navbar navbar-expand-lg navbar-light">
      <router-link class="navbar-brand" to="/">
        <img id="efocs_logo" src="@/assets/images/EFOCS_Logo_Horizontal.svg" alt="EFOCS" @click.prevent="goToDashboard()" />
      </router-link>
      <div v-if="1200 < getWindowsWidth" id="exchangeSelectArea" class="dropdown">
        <button
          id="selectExchange"
          class="btn btn-light form-select exchange-select-button"
          type="button"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          <span class="exchange-option-content">
            <img :src="getSelectedExchangeLogo()" class="exchange-option-logo" alt="" />
            <span class="exchange-option-label">{{ getSelectedExchangeLabel() }}</span>
          </span>
        </button>
        <ul class="dropdown-menu exchange-dropdown-menu" aria-labelledby="selectExchange">
          <li>
            <button class="dropdown-item exchange-dropdown-item" type="button" @click.prevent="selectExchange(0)">
              <img :src="exchangeLogos.ALLX" class="exchange-option-logo" alt="" />
              <span>{{ getAllExchangesSelectLabel() }}</span>
            </button>
          </li>
          <li v-for="exchange in getExchanges" :key="exchange.eID">
            <button class="dropdown-item exchange-dropdown-item" type="button" @click.prevent="selectExchange(exchange.eID)">
              <img :src="getExchangeLogo(exchange)" class="exchange-option-logo" alt="" />
              <span>{{ getExchangeSelectLabel(exchange) }}</span>
            </button>
          </li>
        </ul>
      </div>
      <div v-if="1200 < getWindowsWidth" id="searchContainer">
        <div class="row">
          <div id="searchArea" class="input-group">
            <div class="input-group-prepend">
              <button class="btn btn-outline-secondary btn-light" id="inputGroup-sizing-sm"
                @click.prevent="forceSearch">
                <i class="icon ion-md-search"></i>
              </button>
            </div>
            <input id="searchInput" type="text" class="form-control" :placeholder="t('searchPlaceholder')"
              aria-describedby="inputGroup-sizing-sm" v-model="search" ref="seachInput" />
              <div v-if="search" class="input-group-append search-clear-container">
                <button class="btn btn-outline-secondary btn-light search-clear-button" type="button"
                @click.prevent="search = ''; $refs.seachInput?.focus();">X</button>
            </div>
          </div>
        </div>
        <!-- dropdown search -->
        <div class="row">
          <div id="searchResults" class="card" v-if="hasSearchQueryMinimumLength">
            <div class="card-body">
              <div id="searchResultsContainer" class="container">
                <SearchResultsDropdown
                  :groups="groupedSearchResults"
                  :no-matching-label="t('noMatchingInstrumentsFoundLabel')"
                  @select="openExtendedInfo"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- user menu -->
      <button v-if="1200 < getWindowsWidth" class="navbar-toggler" type="button" data-bs-toggle="collapse"
        data-bs-target="#headerNav" aria-controls="headerNav" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div v-if="1200 < getWindowsWidth" class="collapse navbar-collapse " id="headerNav">
        <ul class="navbar-nav ml-auto ">
          <li class="nav-item dropdown header-img-icon">
            <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown5" role="button" data-bs-toggle="dropdown"
              aria-expanded="false">
              <div class="container">
                <div class="img-overlay-wrap">
                  <img src="@/assets/images/EFOCS_Avatar.svg" class="header-avatar-image rounded-circle"
                    alt="avatar" />
                  <svg class="svg-rect" width="80" height="20">
                    <rect x="0" y="0" rx="3" ry="3" width="80" height="20" :fill="getUserTypeFillColor"></rect>
                    <text class="avatar_text pt-4" x="50%" y="50%" text-anchor="middle" stroke="white"
                      stroke-width="1px" dy=".3em">{{ getUserTypeString }}</text>
                  </svg>
                </div>
              </div>
            </a>
            <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="navbarDropdown5">
              <div class="dropdown-body">
                <ul class="profile-nav">
                  <li class="nav-item">
                    <router-link :to="{ name: 'Profile', query: { selectedMenuItem: 'main' } }" class="nav-link">
                      <i class="icon ion-md-lock"></i>
                      <span>{{ t("mainLabel") }}</span>
                    </router-link>
                  </li>
                  <li class="nav-item">
                    <router-link :to="{ name: 'Profile', query: { selectedMenuItem: 'language' } }" class="nav-link">
                      <i class="icon ion-md-flag"></i>
                      <span>{{ t("languageMenuItem") }}</span>
                    </router-link>
                  </li>
                  <li class="nav-item">
                    <router-link :to="{ name: 'Profile', query: { selectedMenuItem: 'password' } }" class="nav-link">
                      <i class="icon ion-md-lock"></i>
                      <span>{{ t("passwordMenuItem") }}</span>
                    </router-link>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" target="_blank" rel="noopener noreferrer" href="https://payments.eurofinance.bg/">
                      <i class="icon ion-md-card"></i>
                      <span>{{ t("addFundsLabel") }}</span>
                    </a>
                  </li>
                  <li v-if="1 === getUserType()" class="nav-item">
                    <router-link :to="{ name: 'Profile', query: { selectedMenuItem: 'withdraw' } }" class="nav-link">
                      <i class="icon ion-md-log-out"></i>
                      <span>{{ t("withdrawLabel") }}</span>
                    </router-link>
                  </li>
                  <li v-else class="nav-item">
                    <a class="nav-link" target="_blank" rel="noopener noreferrer" href="https://eurofinance.bg/">
                      <i class="icon ion-md-log-out"></i>
                      <span>{{ t("withdrawLabel") }}</span>
                    </a>
                  </li>
                  <li class="nav-item">
                    <router-link :to="{ name: 'Login' }" class="nav-link red" @click="doLogout()">
                      <i class="icon ion-md-power"></i>
                      <span>{{ t("logoutMenuItem") }}</span>
                    </router-link>
                  </li>
                </ul>
              </div>
            </ul>
          </li>
        </ul>
      </div>
      <!-- responsive layout -->
      <div v-if="1200 > getWindowsWidth" class="input-group d-flex justify-content-end">
        <div id="exchangeSelectArea" class="dropdown">
          <button
            id="selectExchangeMobile"
            class="btn btn-light form-select form-select-sm exchange-select-button"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <span class="exchange-option-content">
              <img :src="getSelectedExchangeLogo()" class="exchange-option-logo" alt="" />
              <span class="exchange-option-label">{{ getSelectedExchangeLabel() }}</span>
            </span>
          </button>
          <ul class="dropdown-menu exchange-dropdown-menu" aria-labelledby="selectExchangeMobile">
            <li>
              <button class="dropdown-item exchange-dropdown-item" type="button" @click.prevent="selectExchange(0)">
                <img :src="exchangeLogos.ALLX" class="exchange-option-logo" alt="" />
                <span>{{ getAllExchangesSelectLabel() }}</span>
              </button>
            </li>
            <li v-for="exchange in getExchanges" :key="exchange.eID">
              <button class="dropdown-item exchange-dropdown-item" type="button" @click.prevent="selectExchange(exchange.eID)">
                <img :src="getExchangeLogo(exchange)" class="exchange-option-logo" alt="" />
                <span>{{ getExchangeSelectLabel(exchange) }}</span>
              </button>
            </li>
          </ul>
        </div>
        <!-- Modal search on lower resolutions -->
        <div v-if="1200 > getWindowsWidth" class="modal fade" tabindex="-1" role="dialog"
          aria-labelledby="searchInstrument" aria-hidden="true"
          :class="{ 'show': searchModalShow, 'd-block': searchModalActive }">
          <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="searchInstrument">{{ t("searchPlaceholder") }}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal()">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <div id="searchContainerModal" class="container-fluid">
                  <div class="row">
                    <div id="searchAreaModal" class="input-group">
                      <div class="input-group-prepend">
                        <button class="btn btn-outline-secondary btn-light" id="inputGroup-sizing-sm-modal"
                          @click.prevent="forceSearch">
                          <i class="icon ion-md-search"></i>
                        </button>
                      </div>
                      <input id="searchInputModal" type="text" class="form-control" :placeholder="t('searchPlaceholder')"
                        aria-describedby="inputGroup-sizing-sm-modal" v-model="search" ref="searchInputModal" />
                      <div v-if="search" class="input-group-append search-clear-container">
                        <button class="btn btn-outline-secondary btn-light search-clear-button" type="button"
                          @click.prevent="search = ''; $refs.searchInputModal?.focus();">X</button>
                      </div>
                    </div>
                  </div>
                  <!-- dropdown search -->
                  <div class="row">
                    <div id="searchResultsModal" class="card" v-if="hasSearchQueryMinimumLength">
                      <div class="card-body">
                        <div id="searchResultsContainerModal" class="container">
                          <SearchResultsDropdown
                            compact
                            :groups="groupedSearchResults"
                            :no-matching-label="t('noMatchingInstrumentsFoundLabel')"
                            @select="openExtendedInfo"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="1200 < getWindowsWidth" id="searchContainer">
          <div class="row">
            <div id="searchArea" class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text" id="inputGroup-sizing-sm" @click.prevent="forceSearch">
                  <i class="icon ion-md-search"></i>
                </span>
              </div>
              <input id="searchInput" type="text" class="form-control" :placeholder="t('searchPlaceholder')"
                aria-describedby="inputGroup-sizing-sm" v-model="search" ref="seachInput" />
              <div v-if="search" class="input-group-append search-clear-container">
                <button class="btn btn-secondary search-clear-button" type="button"
                  @click.prevent="search = ''; $refs.seachInput?.focus();">X</button>
              </div>
            </div>
          </div>
          <!-- dropdown search -->
          <div class="row">
            <div id="searchResults" class="card" v-if="hasSearchQueryMinimumLength">
              <div class="card-body">
                <div id="searchResultsContainer" class="container">
                  <SearchResultsDropdown
                    compact
                    :groups="groupedSearchResults"
                    :no-matching-label="t('noMatchingInstrumentsFoundLabel')"
                    @select="openExtendedInfo"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- show search button -->
        <button v-if="1200 > getWindowsWidth" class="btn btn-sm ms-1 me-1" @click.prevent="openModal">
          <i class="icon ion-md-search"></i>
        </button>
        <!-- user menu -->
        <button v-if="1200 < getWindowsWidth" class="btn btn-sm navbar-toggler" type="button" data-bs-toggle="collapse"
          data-bs-target="#headerNav" aria-controls="headerNav" aria-expanded="true" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div v-if="1200 < getWindowsWidth" class="collapse navbar-collapse " id="headerNav">
          <ul class="navbar-nav ml-auto ">
            <li class="nav-item dropdown header-img-icon">
              <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown5" role="button" data-bs-toggle="dropdown"
                aria-expanded="false">
                <div class="container">
                  <div class="img-overlay-wrap">
                    <img src="@/assets/images/EFOCS_Avatar.svg" class="header-avatar-image rounded-circle"
                      alt="avatar" />
                    <svg class="svg-rect" width="80" height="20">
                      <rect x="0" y="0" rx="3" ry="3" width="80" height="20" :fill="getUserTypeFillColor"></rect>
                      <text class="avatar_text pt-4" x="50%" y="50%" text-anchor="middle" stroke="white"
                        stroke-width="1px" dy=".3em">{{ getUserTypeString }}</text>
                    </svg>
                  </div>
                </div>
              </a>
              <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="navbarDropdown5">
                <div class="dropdown-body">
                  <ul class="profile-nav">
                    <li class="nav-item">
                      <router-link :to="{ name: 'Profile', query: { selectedMenuItem: 'main' } }" class="nav-link">
                        <i class="icon ion-md-lock"></i>
                        <span>{{ t("mainLabel") }}</span>
                      </router-link>
                    </li>
                    <li class="nav-item">
                      <router-link :to="{ name: 'Profile', query: { selectedMenuItem: 'language' } }" class="nav-link">
                        <i class="icon ion-md-flag"></i>
                        <span>{{ t("languageMenuItem") }}</span>
                      </router-link>
                    </li>
                      <li class="nav-item">
                        <router-link :to="{ name: 'Profile', query: { selectedMenuItem: 'password' } }" class="nav-link">
                          <i class="icon ion-md-lock"></i>
                          <span>{{ t("passwordMenuItem") }}</span>
                        </router-link>
                      </li>
                      <li class="nav-item">
                        <a class="nav-link" target="_blank" rel="noopener noreferrer" href="https://payments.eurofinance.bg/">
                          <i class="icon ion-md-card"></i>
                          <span>{{ t("addFundsLabel") }}</span>
                        </a>
                      </li>
                      <li v-if="1 === getUserType()" class="nav-item">
                        <router-link :to="{ name: 'Profile', query: { selectedMenuItem: 'withdraw' } }" class="nav-link">
                          <i class="icon ion-md-log-out"></i>
                          <span>{{ t("withdrawLabel") }}</span>
                        </router-link>
                      </li>
                      <li v-else class="nav-item">
                        <a class="nav-link" target="_blank" rel="noopener noreferrer" href="https://eurofinance.bg/">
                          <i class="icon ion-md-log-out"></i>
                          <span>{{ t("withdrawLabel") }}</span>
                        </a>
                      </li>
                      <li class="nav-item">
                        <router-link :to="{ name: 'Login' }" class="nav-link red" @click="doLogout()">
                          <i class="icon ion-md-power"></i>
                          <span>{{ t("logoutMenuItem") }}</span>
                        </router-link>
                    </li>
                  </ul>
                </div>
              </ul>
            </li>
          </ul>
        </div>
        <!-- Modal show menu -->
        <div class="modal fade" tabindex="-1" role="dialog" aria-labelledby="showMenu" aria-hidden="true"
          :class="{ 'show': menuModalShow, 'd-block': menuModalActive }">
          <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">{{ t("menuLabel") }}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                  @click="menuModalShow = false; menuModalActive = false;">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <div class="row">
                  <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#headerNav"
                    aria-controls="headerNav" aria-expanded="true" aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span>
                  </button>
                  <div class="collapse navbar-collapse " id="headerNav">
                    <ul class="navbar-nav ml-auto ">
                      <li class="nav-item dropdown header-img-icon">
                        <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown5" role="button"
                          data-bs-toggle="dropdown" aria-expanded="false">
                          <div class="container">
                            <div class="img-overlay-wrap">
                              <img src="@/assets/images/EFOCS_Avatar.svg" class="header-avatar-image rounded-circle"
                                alt="avatar" />
                              <svg class="svg-rect" width="80" height="20">
                                <rect x="0" y="0" rx="3" ry="3" width="80" height="20" :fill="getUserTypeFillColor">
                                </rect>
                                <text class="avatar_text pt-4" x="50%" y="50%" text-anchor="middle" stroke="white"
                                  stroke-width="1px" dy=".3em">{{ getUserTypeString }}</text>
                              </svg>
                            </div>
                          </div>
                        </a>
                        <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="navbarDropdown5">
                          <div class="dropdown-body">
                            <ul class="profile-nav">
                              <li class="nav-item">
                                <router-link :to="{ name: 'Profile', query: { selectedMenuItem: 'main' } }"
                                  class="nav-link">
                                  <i class="icon ion-md-lock"></i>
                                  <span>{{ t("mainLabel") }}</span>
                                </router-link>
                              </li>
                              <li class="nav-item">
                                <router-link :to="{ name: 'Profile', query: { selectedMenuItem: 'language' } }"
                                  class="nav-link">
                                  <i class="icon ion-md-flag"></i>
                                  <span>{{ t("languageMenuItem") }}</span>
                                </router-link>
                              </li>
                              <li class="nav-item">
                                <router-link :to="{ name: 'Profile', query: { selectedMenuItem: 'password' } }"
                                  class="nav-link">
                                  <i class="icon ion-md-lock"></i>
                                  <span>{{ t("passwordMenuItem") }}</span>
                                </router-link>
                              </li>
                              <li class="nav-item">
                                <a class="nav-link" target="_blank" rel="noopener noreferrer" href="https://payments.eurofinance.bg/">
                                  <i class="icon ion-md-card"></i>
                                  <span>{{ t("addFundsLabel") }}</span>
                                </a>
                              </li>
                              <li v-if="1 === getUserType()" class="nav-item">
                                <router-link :to="{ name: 'Profile', query: { selectedMenuItem: 'withdraw' } }"
                                  class="nav-link">
                                  <i class="icon ion-md-log-out"></i>
                                  <span>{{ t("withdrawLabel") }}</span>
                                </router-link>
                              </li>
                              <li v-else class="nav-item">
                                <a class="nav-link" target="_blank" rel="noopener noreferrer" href="https://eurofinance.bg/">
                                  <i class="icon ion-md-log-out"></i>
                                  <span>{{ t("withdrawLabel") }}</span>
                                </a>
                              </li>
                              <li class="nav-item">
                                <router-link :to="{ name: 'Login' }" class="nav-link red" @click="doLogout()">
                                  <i class="icon ion-md-power"></i>
                                  <span>{{ t("logoutMenuItem") }}</span>
                                </router-link>
                              </li>
                            </ul>
                          </div>
                        </ul>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="row">
                  <AppMenu></AppMenu>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- user menu in responsive -->
        <button v-if="1200 > getWindowsWidth" type="button" class="btn btn-sm"
          @click.prevent="menuModalShow = true; menuModalActive = true;">
          <span class="navbar-toggler-icon"></span>
        </button>
      </div>
    </nav>
  </header>
</template>

<script>
import http from "@/api/http-common";
import UiUtils from "@/assets/js/ui_utils.js";
import I18n from "@/lang/i18n.js";
import AppMenu from "@/components/ui/AppMenu.vue";
import SearchResultsDropdown from "@/components/ui/SearchResultsDropdown.vue";
import { getGroupedSearchResults, hasSearchQueryMinimumLength, performInstrumentSearch } from "@/components/ui/header-search.js";
import { getAllExchangesSelectLabel, getExchangeSelectLabel, sortExchanges } from "@/assets/js/exchange_labels.js";
import allExchangesLogo from "@/assets/images/XALL-EF.svg";
import bfbLogo from "@/assets/images/XBUL.svg";
import deutscheBoerseLogo from "@/assets/images/Deutsche-Boerse_Logo.svg";

export default {
  components: {
    AppMenu,
    SearchResultsDropdown,
  },
  data() {
    return {
      /* the searching user typed in input */
      search: "",
      /* 0 - all exchanges, other: exchange id */
      selectedExchange: 0,      
      lastTypechange: 0,
      searchModalShow: false,
      searchModalActive: false,
      menuModalShow: false,
      menuModalActive: false,
      exchangeLogos: {
        ALLX: allExchangesLogo,
        XBUL: bfbLogo,
        XETR: deutscheBoerseLogo,
        XFRA: deutscheBoerseLogo,
      }
    }
  },
  watch: {
    search: function (newVal) {
      // check search
      this.searchModalActive = 0 !== newVal.length;
      (async () => await this.performSearch())();
    },
    selectedExchange: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$store.commit("setSelectedExchangeCode", parseInt(newVal));
      }
    },
    getCurrentRouteName: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.search = "";
      }
    },
    $route(_to, _from) {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      void _to; void _from;

      this.menuModalShow = false; 
      this.menuModalActive = false;
    }
  },
  updated() {
    if (this.search) {
      // after components update during search we lose focus
      // so we reset it here
      this.$nextTick(() => {
        this.$refs.seachInput?.focus();
      });
    }
  },
  methods: {
    openModal() {
      this.searchModalShow = true;
      this.searchModalActive = true;
    },
    closeModal() {
      this.searchModalShow = false;
      this.searchModalActive = false;
    },
    async performSearch() {
      await performInstrumentSearch(this.$store, this.getUserType(), this.search);
    },
    getExchangeCodeString(code) {
      const exchanges = this.$store.getters["getExchanges"];
      return UiUtils.getExchangeCodeById(exchanges, code);
    },
    selectExchange(exchangeId) {
      this.selectedExchange = parseInt(exchangeId);
    },
    getSelectedExchange() {
      return this.getExchanges.find(exchange => parseInt(exchange.eID) === parseInt(this.selectedExchange));
    },
    getSelectedExchangeLabel() {
      const exchange = this.getSelectedExchange();
      return exchange ? this.getExchangeSelectLabel(exchange) : this.getAllExchangesSelectLabel();
    },
    getSelectedExchangeLogo() {
      const exchange = this.getSelectedExchange();
      return exchange ? this.getExchangeLogo(exchange) : this.exchangeLogos.ALLX;
    },
    getExchangeLogo(exchange) {
      const code = exchange?.code?.toString().toUpperCase() || "";
      return this.exchangeLogos[code] || this.exchangeLogos.ALLX;
    },
    getAllExchangesSelectLabel() {
      return getAllExchangesSelectLabel(this.getUserLanguage());
    },
    getExchangeSelectLabel(exchange) {
      return getExchangeSelectLabel(exchange, this.getUserLanguage());
    },
    getUserType() {
      return this.$store.getters["getUserType"];
    },
    toggleDark: function () {
      this.$store.commit("changeTheme");
      document.body.classList.toggle("dark");
    },
    async doLogout() {
      const user = this.$store.getters["getUser"];
      await http.getApiClient(this.getUserType()).get("", {
        params: {
          a: "logout",
          id: user.id,
          key: user.key
        }
      })
        .then(res => {
          if (0 === res.data.ec) {
            // reset store to avoid users access to other user's data
            this.$store.commit("resetStoreState", null);
            this.$store.commit("wallet/resetWalletState");
            // redirect
            this.$store.commit("setUser", null);
            // hide headers
            this.$store.setAppStateNotReady;
            // reset all values
            this.search = "";
            this.lastTypechange = 0;
            this.$router.push({ name: "Login" });
          }
        })
        .catch(e => {
          console.error(e);
        });
    },
    getUserLanguage() {
      return this.$store.getters["getNonLoggedInLanguage"]?.toUpperCase() || "EN";
    },
    parseUnixMsTime(itemTime) {
      return UiUtils.parseUnixMsTime(itemTime);
    },
    forceSearch() {
      this.search = this.search + " ";
    },
    openExtendedInfo(stock) {
      let stockCMic = 1;
      if (0 === 'XETR'.localeCompare(stock.xc?.toUpperCase())) {
        stockCMic = 2;
      } else if (0 === 'XFRA'.localeCompare(stock.xc?.toUpperCase())) {
        stockCMic = 3;
      }
      this.$store.commit("setSuppressSelectedTradingQuoteSync", true);
      this.$store.commit("setSelectedTradingCode", stock.code);
      this.$store.commit("setSelectedTradingCodeSegment", stock.sgm);
      this.$store.commit("setSelectedTradingCodeShareTypeId", stock.stid ?? stock.tID);
      this.$store.commit("setSelectedTradingExchangeId", stockCMic);
      this.$store.commit("setSelectedTradingStockName", 
        0 === "EN".localeCompare(this.getUserLanguage().toUpperCase())
        ? stock.nEN
        : stock.nBG ? stock.nBG : stock.nEN);
      // hide search dropdown
      this.search = "";
      // move to exdended info if not already there
      if (0 !== "ExtendedStock".localeCompare(this.$route.name)) {
        this.$router.push({ name: "ExtendedStock", params: { stockCode: stock.code, itemExchangeId: stockCMic, itemStockCodeSegment: stock.sgm } })
          .finally(() => setTimeout(() => this.$store.commit("setSuppressSelectedTradingQuoteSync", false), 0));
      } else {
        setTimeout(() => this.$store.commit("setSuppressSelectedTradingQuoteSync", false), 0);
      }
    },
    goToDashboard() {
      this.$router.push({ name: "Dashboard" });
    },
    t(key, ...args) {
      return I18n.t(key, this.getUserLanguage(), ...args);
    }
  },
  computed: {
    getWindowsWidth() {
      return this.$store.getters["getAppWindowWidth"] || window.innerWidth;
    },
    getCurrentRouteName() {
      return this.$route.name;
    },
    getSearchedStocksFromState() {
      return this.$store.getters["getSearchedStocks"];
    },
    getUserTypeString() {
      const userType = this.$store.getters["getUserType"];
      return 0 === userType ? 
        this.t("demoLabel") :
        this.t("liveLabel");
    },
    getUserTypeFillColor() {
      const userType = this.$store.getters["getUserType"];
      return 0 === userType ?
        "#0088AA" :
        "#EC6024";
    },    
    getExchanges() {
      return sortExchanges(this.$store.getters["getExchanges"]);
    },
    searchStockTypeLabels() {
      return {
        bonds: this.t("bondsLabel"),
        cfd: this.t("cfdLabel"),
        compInstruments: this.t("compInstrumentsLabel"),
        equities: this.t("equitiesLabel"),
        equitiesAndEtfs: this.t("stocksAndEtfsLabel"),
        stocksAndEtfs: this.t("stocksAndEtfsLabel"),
        funds: this.t("fundsLabel"),
        margin: this.t("marginLabel"),
        netting: this.t("nettingLabel"),
        other: this.t("othersLabel"),
        unknown: this.t("othersLabel"),
        reits: this.t("reitsLabel"),
        repo: this.t("repoLabel"),
        rights: this.t("rightsLabel"),
      };
    },
    hasSearchQueryMinimumLength() {
      return hasSearchQueryMinimumLength(this.search);
    },
    groupedSearchResults() {
      return getGroupedSearchResults(this.getSearchedStocksFromState, this.search, this.searchStockTypeLabels);
    },
  }
};
</script>

<style scoped>
  .navbar-nav {
    margin-left: auto;
  }
  #searchArea {
    margin-left: 0.7rem;
    max-width: 32rem;
    position: relative;
  }
  #searchAreaModal {
    position: relative;
  }
  #searchInput,
  #searchInputModal {
    padding-right: 2.5rem;
  }
  #searchInput:focus,
  #searchInputModal:focus {
    border-color: #ced4da;
    box-shadow: none;
    outline: 0;
  }
  .search-clear-container {
    position: absolute;
    right: 0.5rem;
    top: 0;
    bottom: 0;
    z-index: 1001;
  }
  .search-clear-button {
    align-items: center;
    background-color: #f8f9fa;
    border: 1px solid #6c757d;
    border-radius: 0.25rem;
    color: #212529;
    display: flex;
    font-size: 1rem;
    height: 2.4rem;
    justify-content: center;
    line-height: 1;
    padding: 0;
    width: 2.4rem;
  }
  .search-clear-button:hover,
  .search-clear-button:focus {
    background-color: #e9ecef;
    border-color: #6c757d;
    color: #212529;
    box-shadow: none;
  }
  #exchangeSelectArea {
    margin-left: 0.7rem;
    width: 20rem;
  }
  .exchange-select-button {
    align-items: center;
    background-color: #fff;
    border: 1px solid #ced4da;
    display: flex;
    height: 2.4rem;
    padding-right: 2rem;
    text-align: left;
    width: 100%;
  }

  .exchange-option-content {
    align-items: center;
    display: flex;
    gap: 0.45rem;
    min-width: 0;
    width: 100%;
  }

  .exchange-option-label {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .exchange-option-logo {
    flex: 0 0 auto;
    height: 1rem;
    object-fit: contain;
    width: 1rem;
  }

  .exchange-dropdown-menu {
    border-radius: 0;
    min-width: 100%;
    padding: 0;
  }

  .exchange-dropdown-item {
    align-items: center;
    display: flex;
    gap: 0.45rem;
    font-size: 1rem;
    min-height: 2.6rem;
  }
  .input-group-prepend {
    cursor: pointer;
  }

  #efocs_logo {
    width: 6.25rem;
    max-width: 100%;
    height: auto;
  }

  #searchResults {
    position: absolute;
    display: flex;
    flex-direction: column; 
    float: left;
    z-index: 999;
    overflow: hidden;
    border:1px solid;
    color: black;
    max-width: 40rem;
  }

  #searchResults .card-body {
    background-color: white;
    width: 100%;
  }

  #searchResultsContainer {
    max-height: 10rem;
    max-width: auto;
    display: flex;
    flex: 1;
    min-height: 0px;
  }

  #searchContainer {
    width: 40rem;
    height: auto;
  }

  .avatar_text {
    top:0;
    left:0;
    font-size: xx-small;
  }

.img-overlay-wrap {
  position: relative;
  display: inline-block; /* <= shrinks container to image size */
  transition: transform 150ms ease-in-out;
}

.img-overlay-wrap img { /* <= optional, for responsiveness */
   display: block;
   max-width: 100%;
   height: auto;
}

.img-overlay-wrap svg {
  position: absolute;
  top: 80%;
  left: -90%;
}
</style>
